const {enum_NODE_ENV, enum_projectEnv_s} = require( "./Share_S_Enum");


export const gv_fun_env  = {
    currentProject_e : enum_projectEnv_s.tq_pro,
    localhost_b: process.env.NODE_ENV === enum_NODE_ENV.production,
    localServer_b: false,
    dbName_s : '',
    storageDebugMode: false,
    createSiteMap_b: false,
}

switch(gv_fun_env.currentProject_e){
    case enum_projectEnv_s.tq_pro:
        gv_fun_env.dbName_s = 'travelquest-searchquest'
        break;
    case enum_projectEnv_s.tq_dev:
        gv_fun_env.dbName_s = 'ongoing'
        break;
    case enum_projectEnv_s.tq_nice:
        break;
}

export const gv_numbers  = {
    finishUploadFile_n: 1,

    mobileRegularWidth: 335,
    tabletRegularWidth: 600,

    screen_mobile_maxWidth: 500,
    screen_table_small_maxWidth: 1000,
    screen_tablet_big_maxWidth: 1280,

    maxImageNum_questExplore: 10,

    minPrice_displayDashboard: -1,
    minPrice_newTicket: 10,
    passwordMinLength: 6,
    shortScreenMaxHeight: 500,
    maxRiddlesNavigationDots: 13,
    defaultColAndRowsNum: 4,
    chatSaveDistance: 20,
    millisecondsInSecond: 1000,
    secondsToOldLocation_n: 5,

    lockTotalTimeInSeconds_min: 1,
    lockTotalTimeInSeconds_max: 200,

    monthsInYear: 12,

    missionPoints_min: 1,
    missionPoints_max: 50,
    leafletMinDistance_n: 0.00001,

    max_videoTimeInSeconds: 60,

    defaultRectangleSize_lng: 0.00425,
    defaultRectangleSize_lat: 0.00325,

    maxFileSizeInByte: 1000 * 1000 * 100, // 100 MB

    minRectangleSize: 0.000009,

    relevantRiddleStatus_seconds: 7,

    ticketManager_minutesToNextAudit : 480,

    dropdown_showSearchBar_minRows : 10,

    maxDurationMinutes : 60*24*7, // one week
    maxTimeExtension : 60*24*7 // one week

}

export const gv_string = {
    baseUrl : "https://TravelQuest.xyz"
}

export const gv_colorsDark = [
    '#800000',
    '#FF8C00',
    '#FFD700',
    '#008000',
    // '#008080',
    '#0000CD',
    '#8A2BE2',
    '#DA70D6',
    '#8B4513',
    '#000000',
    '#add8e6',
    '#0a7b83',
    '#ff6f69',
]